// Capitalize First Letter Filter
export default function CapitalizeFirstLetterFilter(){
	return function(input, all) {
		return !!input
		  ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
		  : "";
	  };
}